// Small copies of uploaded pictures, from the backend's /img route
// (rushmyfood-backend/src/utils/resizedImages.js).
//
// Cards used to draw the original upload: a category icon is a 1024px PNG of
// ~1.3MB shown at 64px. resizedImage(url, 240) asks the same server for a WebP
// 240px wide instead. Ask for about twice the size it is drawn at, for sharp
// screens; the width is rounded up to one the server makes. Anything that is
// not one of our uploads (a bundled asset, an outside link, a preview of a file
// being picked) comes back unchanged.
import { SERVER_URL } from "./global";

// Must match the backend's WIDTHS, IMAGE_EXT and SAFE_PATH.
const WIDTHS = [128, 240, 480, 800, 1200];
const IMAGE_EXT = /\.(jpe?g|png|webp|gif)$/i;
const SAFE_PATH = /^[A-Za-z0-9_-][A-Za-z0-9._-]*(\/[A-Za-z0-9_-][A-Za-z0-9._-]*)*$/;

const OUR_HOSTS = new Set(["server.rushmyfood.com", "rushmyfoodapp-production.up.railway.app"]);
try {
  OUR_HOSTS.add(new URL(SERVER_URL).host);
} catch (e) {
  // no usable server URL; the two hosts above still count
}

export function resizedImage(src, width) {
  if (!src || typeof src !== "string") return src;
  let url;
  try {
    url = new URL(src);
  } catch (e) {
    return src;
  }
  if (!OUR_HOSTS.has(url.host) || url.search) return src;
  const match = url.pathname.match(/^\/uploads\/(.+)$/);
  if (!match) return src;
  const file = match[1];
  if (!SAFE_PATH.test(file) || !IMAGE_EXT.test(file) || file.startsWith("_resized/")) return src;
  const size = WIDTHS.find((w) => w >= width) || WIDTHS[WIDTHS.length - 1];
  return `${url.origin}/img/${size}/${file}`;
}

// For pictures whose drawn width changes with the screen: an <img srcSet> the
// browser picks from (pair it with `sizes`). Undefined when the picture is not
// one of our uploads, so the plain src is used.
export function resizedSrcSet(src, widths) {
  if (resizedImage(src, widths[0]) === src) return undefined;
  return widths.map((w) => `${resizedImage(src, w)} ${w}w`).join(", ");
}
